// extracted by mini-css-extract-plugin
export var errorIcon = "_n9-1";
export var nameLogo = "_n9-0";